import React from "react";
import { BaseButtons, TextInputField } from "../../../common-components";
import { colors } from "../../../../themes/Colors";

const Profile = ({ display, height, setSubSelection }) => {
  return (
    <div
      style={{
        height: display ? "100%" : 0,
        overflowY: "auto",
        maxHeight:
          height > 400
            ? height > 600
              ? height > 750
                ? 650
                : 600
              : 500
            : 400,
        minHeight: display ? (display ? 350 : 0) : 0,
        // transition: "height 0.4s",
        width: display ? "100%" : 0,
        bottom: 0,
      }}
    >
      <div
        style={{
          width: "100%",
          marginTop: 20,
          marginBottom: 20,
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ marginLeft: 25, marginRight: 10 }}>
          <BaseButtons
            label={"BACK"}
            borderRadius={8}
            backgroundColor={colors.orangeDark}
            width={70}
            height={35}
            onClick={() => setSubSelection("dashboard")}
          />
        </div>
        <div style={{ fontWeight: "bold", fontSize: 22 }}>
          BASIC INFORMATION
        </div>
      </div>
      <TextInputField
        labelTitle={"First Name"}
        mini={true}
        width={"100%"}
        size={"80%"}
      />
      <TextInputField
        labelTitle={"Last Name"}
        mini={true}
        width={"100%"}
        size={"80%"}
      />
      <TextInputField
        labelTitle={"Email"}
        mini={true}
        width={"100%"}
        size={"80%"}
      />
      <TextInputField
        labelTitle={"Cell number"}
        mini={true}
        width={"100%"}
        size={"80%"}
      />

      <div style={{ padding: 40 }} />
    </div>
  );
};

export default Profile;
